interface HeaderProps {
  isVisible: boolean;
}

export const Header = ({ isVisible }: HeaderProps) => {
  if (!isVisible) return null;

  return (
    <header className="fixed top-0 w-full bg-white/80 backdrop-blur-sm z-50">
      <div className="container mx-auto flex items-center justify-end h-16">
        <nav className="hidden md:flex space-x-8">
          <a href="#portfolio" className="hover:text-gray-600">
            Portfolio
          </a>
          <a href="#about" className="hover:text-gray-600">
            About
          </a>
          <a href="#contact" className="hover:text-gray-600">
            Contact
          </a>
        </nav>
      </div>
    </header>
  );
};
